import Modal from "../../../../../../components/blocks/Modal";
import AttachmentCard from "../../../../../../components/blocks/AttachmentCard";

type ReceiptBtnProps = {
    t: (key: string) => string;
    courseOrderData: any;
    open: boolean;
    setOpen: (state: boolean) => void;
};

export const ReceiptBtn = ({ t, courseOrderData, open, setOpen }: ReceiptBtnProps) => (
    <>
        <button className="btn btn-link" type="button" onClick={() => setOpen(true)}>
            {t("receipt")}
        </button>
        <Modal
            isOpen={open}
            onClose={() => setOpen(false)}
            containerClassName="bg-white"
            size="lg"
            title={t("receipt")}
        >
            <div>
                <div className="d-flex gap-3 mt-2">
                    {courseOrderData?.authorAmountFiles?.length ? (
                        courseOrderData.authorAmountFiles.map((attachment: any) => (
                            <AttachmentCard
                                key={attachment.id}
                                attachment={{
                                    id: attachment.id,
                                    fileName: attachment.name ?? "",
                                    size: attachment.size ?? "",
                                    extension: attachment.extension ?? "",
                                }}
                            />
                        ))
                    ) : (
                        <span>{t("allowanceReward")}</span>
                    )}
                </div>
            </div>
        </Modal>
    </>
);